import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";

import { AvatarComponent } from "@shared/components/avatar/avatar.component";

export interface LastUpdate {
  name: string;
  id: number;
  lastUpdatedSection: string;
  lastUpdatedDate: string;
  lastUpdatedText: string;
}

@Component({
  selector: "app-last-update-card",
  imports: [CommonModule, MatIconModule, AvatarComponent],
  templateUrl: "./last-update-card.component.html",
  styleUrl: "./last-update-card.component.scss",
})
export class LastUpdateCardComponent {
  @Input() lastUpdate!: LastUpdate;
}
